import { render, staticRenderFns } from "./ShiftBoardItem.vue?vue&type=template&id=9054cc64&scoped=true"
import script from "./ShiftBoardItem.vue?vue&type=script&lang=js"
export * from "./ShiftBoardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9054cc64",
  null
  
)

export default component.exports